/**
 * VariantAnalysis — a row from variant-analysis.sqlite: the precomputed
 * KJV (TR) vs NASB (WH) Strong's-number comparison for one verse.
 *
 * score: 0 = order-only (benign), 1 = minor, 2 = subtil, 3 = major.
 */
import { z } from 'zod';
export const VariantAnalysisSchema = z.object({
    reference: z.string(),
    score: z.number(),
    category: z.string(),
    impact: z.string(),
    shortSummary: z.string(),
    summary: z.string(),
    numberSummary: z.string(),
    kjvNumbers: z.array(z.string()),
    nasbNumbers: z.array(z.string()),
    onlyInKjv: z.array(z.string()),
    onlyInNasb: z.array(z.string()),
    affectedConcepts: z.array(z.string()),
    isHumanReviewed: z.boolean(),
});
//# sourceMappingURL=variant-analysis.js.map